import classNames from "classnames";
import Modal from "components/Modal/Modal";
import { NavLink, useNavigate } from "react-router-dom";
import styles from "./Dashboard.module.scss";
import { dashboardLiks } from "./NavLinks";
import logo from "assets/icons/logoDark.svg";
import Button from "components/Button/Button";
import { handleButtonClick } from "analytics";
import { useContext } from "react";
import { AuthContext } from "context/AuthContext";

type DashMobileNavProps = {
  close: () => void;
};
function DashBoardMobile({ close }: DashMobileNavProps) {
  const navigate = useNavigate();
  const { handleLogout } = useContext(AuthContext);

  const handleSignOut = () => {
    handleLogout();
    handleButtonClick("Log out button Clicked");
    navigate("/login");
  };
  return (
    <Modal onClose={close}>
      <div className={styles.sideMobile}>
        <div>
          <div className={styles.dashLogo}>
            <img src={logo} alt="logo" />
          </div>
          <ul className={styles.sideNavLinks}>
            {dashboardLiks.map((item, index) => (
              <li key={index} onClick={() => close()}>
                <NavLink to={item.link}>
                  {({ isActive }) => {
                    return isActive ? (
                      <div
                        className={classNames([
                          styles.dashLinks,
                          styles.active,
                        ])}
                      >
                        {item.activeIcon}
                        {item.name}
                      </div>
                    ) : (
                      <div className={styles.dashLinks}>
                        {item.icon}
                        {item.name}
                      </div>
                    );
                  }}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className={styles.logoutBtn}>
            <Button
              text="Log Out"
              color="dark"
              onClick={handleSignOut}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default DashBoardMobile;
